import { render, staticRenderFns } from "./optNode.vue?vue&type=template&id=7a127997&scoped=true&"
import script from "./optNode.vue?vue&type=script&lang=js&"
export * from "./optNode.vue?vue&type=script&lang=js&"
import style0 from "./optNode.vue?vue&type=style&index=0&id=7a127997&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a127997",
  null
  
)

export default component.exports